/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface EmailSystemActionConfigurationScope extends angular.IScope {
        model: models.EmailSystemActionsModel
    }

    export class EmailSystemActionConfigurationController implements IController {
        constructor(
            private scope: EmailSystemActionConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            growlService: angular.growl.IGrowlService,
            processConfigurationService: services.ProcessConfigurationService,
            treeService: services.TreeService,
            treeItemService: services.TreeItemService,
            manageStaticDocumentsService: services.ManageStaticDocumentsService,
            systemLevelService: services.SystemLevelService,
            emailConfigurationService: services.EmailConfigurationService,
            deleteService: services.DeleteService,
            contentPageService: services.ContentPageService,
            processTypeService: services.ProcessTypeService,
            formService: services.FormService,
            modalService: any)
        {
            var processConfigurationId = $routeParams["id"];

            this.scope.model = new models.EmailSystemActionsModel(
                scope,
                growlService,
                processConfigurationId,
                processConfigurationService,
                treeService,
                treeItemService,
                manageStaticDocumentsService,
                systemLevelService,
                emailConfigurationService,
                deleteService,
                contentPageService,
                processTypeService,
                formService,
                modalService);
        }
    }
}

warsApp.registerController('EmailSystemActionConfigurationController',
    ['$scope', '$routeParams', 'growl', 'processConfigurationService', 'treeService', 'treeItemService',
        'manageStaticDocumentsService', 'systemLevelService', 'emailConfigurationService', 'deleteService', 'contentPageService', 'processTypeService', 'formService', 'ModalService']
);